import { useEffect, useRef } from 'react'

export const useScrollHandler = (
  handler: (event: Event) => void,
  listenIf = true,
) => {
  const scrollHandlerRef = useRef<((event: Event) => void) | null>(null)

  useEffect(() => {
    const cleanUp = () => {
      if (scrollHandlerRef.current) {
        document.removeEventListener('scroll', scrollHandlerRef.current)
      }
    }

    if (listenIf) {
      cleanUp()

      scrollHandlerRef.current = (event) => {
        event.preventDefault()
        event.stopPropagation()

        handler(event)
      }
      document.addEventListener('scroll', scrollHandlerRef.current)
    }

    return cleanUp
  }, [handler, listenIf])
}
